var swiper = new Swiper('.video-box-slider', {
  slidesPerView: 'auto',
  centeredSlides: false,
  paginationClickable: true,
  loop: false,
  slideToClickedSlide: true,
  breakpoints: {
    // when window width is >= 320px
    749: {
      loop: false,
       slidesPerView: 'auto',
      centeredSlides: false,
    }
  }
});


var swiper = new Swiper('.Ingredients_slider', {
  slidesPerView: 'auto',
  centeredSlides: false,
  paginationClickable: true,
  loop: true,
  slideToClickedSlide: true,
   navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

  breakpoints: {
    // when window width is >= 320px
    749: {
      loop: true,
       slidesPerView: 'auto',
      centeredSlides: false,
    }
  }
});



var swiper = new Swiper('.reveiw_slider', {
  slidesPerView: 'auto',
  centeredSlides: true,
  paginationClickable: true,
  loop: true,
  slideToClickedSlide: true,
  breakpoints: {
    // when window width is >= 320px
    749: {
      loop: true,
       slidesPerView: 'auto',
      centeredSlides: true,
    }
  }
});


document.addEventListener('DOMContentLoaded', function () {
  const faqQuestions = document.querySelectorAll('.accordion-heading');

  faqQuestions.forEach(function (question) {
     question.addEventListener('click', function () {
        const answer = this.nextElementSibling;

        answer.style.maxHeight = answer.style.maxHeight ? null : answer.scrollHeight + 'px';
        this.classList.toggle('collapsed');
       this.classList.remove('active-anim');
     });
  });
});

// Featured Collection Tabs JS
const tabButtons = document.querySelectorAll('.collection_tabs_title .tab_title');
tabButtons.forEach(function(tab){
  tab.addEventListener('click', function(){
    const tabID = this.getAttribute('id');
    tabButtons.forEach(classTab=>{
      classTab.classList.remove('active');
    })
    this.classList.add('active');
    const Slider_Component_main_div = this.closest('div.featured-collection-tabbing');
    const Slider_Component = Slider_Component_main_div.querySelectorAll('.featured-collection-content');
    Slider_Component.forEach(function(slider){
      const data_tab_manage = slider.getAttribute('data-tab-manage');
      if(tabID === data_tab_manage){
        slider.style.display = "";
      } else{
        slider.style.display = "none";
      }
    })
  })
})


// product countdown timer js

var CountDown = document.querySelectorAll('.countdown');
CountDown.forEach(function(count){
  if(count){
  // Set the date we're counting down to
  var TimerDate = count.getAttribute("data-timer");
  console.log(TimerDate)
  var countDownDate = new Date(TimerDate).getTime();
  
  // Update the count down every 1 second
  var x = setInterval(function() {
  
    // Get today's date and time
    var now = new Date().getTime();
      
    // Find the distance between now and the count down date
    var distance = countDownDate - now;
    
    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
    // Output the result in an element with id="countdown"

    if(count.hasAttribute('header_countdown')){
      count.innerHTML ="<div> <div>" + days + "</div><span>Days</span></div><small></small><div> <div>" + hours + "</div><span>HRS</span></div><small></small> <div> <div>" +  minutes + "</div><span>MINS</span></div><small></small><div> <div>" + seconds + "</div><span>SECS</span></div>";
    } else{      
      count.innerHTML ="<div> <div>" + days + "</div><span>Days</span></div><small></small><div> <div>" + hours + "</div><span>HRS</span></div><small></small> <div> <div>" +  minutes + "</div><span>MINS</span></div><small></small><div> <div>" + seconds + "</div><span>SECS</span></div>";
    }
    // count.innerHTML ="<div> <div>" + days + "</div><span>DAYS</span></div><small>:</small><div> <div>" + hours + "</div><span>HOURS</span></div><small>:</small> <div> <div>" +  minutes + "</div><span>MINS</span></div><small>:</small><div> <div>" + seconds + "</div><span>SECS</span></div>";
    // count.innerHTML ="<div> <div>" + hours + "</div><span>Std</span></div><small>:</small> <div> <div>" +  minutes + "</div><span>Min</span></div><small>:</small><div> <div>" + seconds + "</div><span>Sek</span></div>";
      
    // If the count down is over, write some text 
    if (distance < 0) {
      clearInterval(x);
      count.innerHTML = "EXPIRED";
      setTimeout(()=>{count.closest('.countdown_timer_main_timer').style.display = "none";},500);
    }
  }, 1000);
}
})

document.addEventListener("DOMContentLoaded", function() {
  // Get all tab link elements
  var tabLinks = document.querySelectorAll(".w-tab-link");

  // Add click event listener to each tab link
  tabLinks.forEach(function(link) {
    link.addEventListener("click", function() {
      // Get the tab ID from data attribute
      var tabId = this.getAttribute("data-tab");

      // Remove active class from all tab links
      document.querySelectorAll(".w-tab-link").forEach(function(tabLink) {
        tabLink.classList.remove("w--current");
      });

      // Add active class to the clicked tab link
      this.classList.add("w--current");

      // Hide all tab contents
      document.querySelectorAll(".w-tab-pane").forEach(function(content) {
        content.classList.remove("w--tab-active");
      });

      // Show the selected tab content
      document.getElementById(tabId).classList.add("w--tab-active");
    });
  });
});

//Custom Product Page tabing JS.
const AllProductTabs = document.querySelectorAll('.tabs_main');
if(AllProductTabs.length > 0){
  AllProductTabs.forEach(productTab=>{    
    const AllTabItmes = productTab.querySelectorAll('.tabstop-part .tabitem');
    const AllTabsCont = productTab.querySelectorAll('.tabsdata-part .tabdata-cont');
    if(AllTabItmes.length > 0){
      AllTabItmes.forEach(item=>{
        if(item){
          item.addEventListener('click', ()=>{
            const item_data_tab = item.getAttribute('data-tab');
            AllTabItmes.forEach(item=>{
              item.classList.remove('active');
            });
            item.classList.add('active');
            if(AllTabsCont.length > 0){
              AllTabsCont.forEach(content=>{
                if(content){
                  const content_data_target = content.getAttribute('data-target');
                  content.classList.remove('tabsdata-show');
                  content.style.display = "none";
                  if(content_data_target == item_data_tab){
                    content.classList.add('tabsdata-show');
                    content.style.display = "block";
                  }
                }
              })
            }
          })
        }
      })
    }
  })
}

// Serving Variant Functionality.
document.addEventListener("DOMContentLoaded", function() {
  if(document.querySelector('.quantity_inr_cover')){
    const quantity_inr_cover = document.querySelector('.quantity_inr_cover');
    if(quantity_inr_cover){
      const AllRadioButtons = quantity_inr_cover.querySelectorAll('.radio__button_1');
      if(AllRadioButtons.length > 0){
        AllRadioButtons.forEach(button=>{
          if(button){
            button.addEventListener('click',()=>{
            const buttonOption = button.getAttribute('data-radio-option');
              sessionStorage.setItem('activeOption', buttonOption);
              const ProductOptions = document.querySelectorAll('[data-product-options] .selector-wrapper.js[data-dropdown]');
              if(ProductOptions.length > 0){
                ProductOptions.forEach(variantOption=>{
                  if(variantOption){
                    const dropdown_for = variantOption.getAttribute('data-dropdown');
                    if(dropdown_for == "serve"){
                      const variant_dropdownTag = variantOption.querySelector('variant-dropdown');
                      const sectionId = variant_dropdownTag.getAttribute('data-section-id');
                      const variant_dropdown = variantOption.querySelector('.variant-dropdown');
                      if(variant_dropdown){
                        const allDropdownOptions = variant_dropdown.querySelectorAll('li[data-dropdown-option]');
                        if(allDropdownOptions.length > 0){
                          allDropdownOptions.forEach(dropdownOption=>{
                            const dropdownOptionValue = dropdownOption.getAttribute('data-option');
                            dropdownOption.classList.remove('selected');
                            dropdownOption.removeAttribute('selected');
                            if(dropdownOptionValue == buttonOption){                              
                              dropdownOption.classList.add('selected');
                              dropdownOption.setAttribute('selected', '');
                            }
                          })
                          eventBus.emit('variant:change', { sectionId: sectionId });
                        }
                      }
                    }
                  }
                })
              }
            })
            const activeOptionId = sessionStorage.getItem('activeOption');
            // console.log("ActiveOption: ", activeOptionId);
            if (activeOptionId) {
                const CurrentOption = document.querySelector(`[data-radio-option = "${activeOptionId}"] input`);
                if (CurrentOption) {
                    CurrentOption.click();
                }
            }
          }
        })
      }
    }
  }
});

const SellingPlan = function SellingPlanWidget (){
  const SellingPlanMainContainer = document.querySelector('.yotpo-selling-plans');
  if(SellingPlanMainContainer){
    document.querySelector('.subscription_tabs').style.display = "block";
    const AllSellingPlanRadioButtons = SellingPlanMainContainer.querySelectorAll('.yotpo-radio-container');
    if(AllSellingPlanRadioButtons.length > 0){
      AllSellingPlanRadioButtons.forEach(button=>{
        if(button){
          button.addEventListener('click',()=>{
            const buttonSellingPlanID = button.getAttribute('data-seling-plan-group-id');
            if(buttonSellingPlanID == "buy-once"){
              if(document.querySelector('[data-subscription-type="onetime"]')){
                document.querySelector('[data-subscription-type="onetime"]').click();
              }
            } else{
              if(document.querySelector('[data-subscription-type="subscription"]')){
                document.querySelector('[data-subscription-type="subscription"]').click();
              }
            }
          })
        }
      })
    }
    clearTimeout(SellingPlan)
  } else{
    setTimeout(SellingPlan, 100);
  }
}

function ReadMore_ReadLess(element){
  const ReadMoreButton = document.querySelectorAll(element);
  if(ReadMoreButton.length > 0){
    ReadMoreButton.forEach(Button=>{
      if(Button){
        Button.addEventListener('click',()=>{
          const ButtonOldText = Button.parentElement.querySelector('.hidden_old_text');
          const OldText = ButtonOldText.getAttribute('data-btn-text');
          if(!Button.classList.contains('active')){
            Button.classList.add('active');
            Button.innerText = "Read Less",
            Button.parentElement.querySelector('.tabs-description_text').style.display = "none";
            Button.parentElement.querySelector('.tabs-description_main_text').style.display = "block";
          } else{
            Button.classList.remove('active');
            Button.innerText = OldText,
            Button.parentElement.querySelector('.tabs-description_text').style.display = "block";
            Button.parentElement.querySelector('.tabs-description_main_text').style.display = "none";
          }
        })
      }
    })
  }
}

document.addEventListener("DOMContentLoaded", function() {
  setTimeout(SellingPlan, 500);
  ReadMore_ReadLess('.read-more-btn');
});



